module.exports = __webpack_public_path__ + "img/00026.4f2284ec.webp";